import { tv } from 'tailwind-variants';

export default tv({
  base: `
    fixed

    left-0
    top-0
    
    z-[100]

    flex
    h-screen
    w-full
    flex-col
    items-center
    justify-center
    
    overflow-x-auto
    bg-gray-900/70
    
    pb-8
  `,
  slots: {
    button: `      
      fixed

      bottom-[15px]
      left-[15px]
      
      h-[45px]
      w-[calc(100%-30px)]      
    `,
  },
});
